import { render, staticRenderFns } from "./big-editorial-slider.vue?vue&type=template&id=49134a6a&scoped=true&"
import script from "./big-editorial-slider.vue?vue&type=script&lang=js&"
export * from "./big-editorial-slider.vue?vue&type=script&lang=js&"
import style0 from "./big-editorial-slider.vue?vue&type=style&index=0&id=49134a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49134a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49134a6a', component.options)
    } else {
      api.reload('49134a6a', component.options)
    }
    module.hot.accept("./big-editorial-slider.vue?vue&type=template&id=49134a6a&scoped=true&", function () {
      api.rerender('49134a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/big-editorial-slider.vue"
export default component.exports